
import { Component, Input } from '@angular/core';
import { ThemeControlsComponent } from '../../theme-controls/theme-controls.component';
import { ThemePlaygroundComponent } from '../../theme-playground/theme-playground.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ResponsiveMode } from '@app/enum/responsiveModes';
import { UiNewViewMode } from '../ui-new-tabs-bar/ui-new-tabs-bar.component';
import { Subscription } from 'rxjs';
import { UiOfferTab } from '@app/_services/shared.service';
import { LxResponsiveClassDirective } from '@app/directives/lx-responsive-class.directive';

export type UiNewTheme = 'dark' | 'light';
export type UiNewStyle = 'neo' | 'zen' | 'classic' | 'lux';

@Component({
  selector: 'ui-new-shell',
  standalone: true,
  imports: [ThemeControlsComponent, LxResponsiveClassDirective, ThemePlaygroundComponent],
  templateUrl: './ui-new-shell.component.html',
  styleUrl: './ui-new-shell.component.scss',
})
export class UiNewShellComponent {
  @Input() theme: UiNewTheme = 'dark';
  @Input() style: UiNewStyle = 'neo';

  readonly shellResponsiveClass = {
    horizontal: 'shell-desktop',
    vertical: 'shell-handset',
  } as const;

  @Input() viewMode: ResponsiveMode | UiNewViewMode = ResponsiveMode.horizontal;
  responsiveMode = ResponsiveMode;

  private breakpointSubscription?: Subscription;

  constructor(private responsive: BreakpointObserver,) {
  }

    isHorizontalMode(): boolean {
    if (typeof this.viewMode === 'string') {
      return this.viewMode === 'tiles';
    }
    return this.viewMode === ResponsiveMode.horizontal;
  }

  isVerticalMode(): boolean {
    return !this.isHorizontalMode();
  }

  ngOnInit(): void {
    this.breakpointSubscription = this.responsive.observe([Breakpoints.HandsetPortrait])
      .subscribe(result => {
        const isHandset = result.breakpoints[Breakpoints.HandsetPortrait];
        this.viewMode = isHandset ? ResponsiveMode.vertical : ResponsiveMode.horizontal;
      });
  }

  ngOnDestroy(): void {
    this.breakpointSubscription?.unsubscribe();
  }

}
